<template>
  <div class="app-container">
    <HeaderLogo />
    <div class="main-content">
      <div class="card">
        <div class="terminal-header">
          <strong>功能操作</strong>
          <span class="link-back" @click="$router.back()">返回到上一页</span>
        </div>

        <div class="terminal-body">
          <div class="row-top">
            <span></span>
          </div>

          <div class="row" style="margin-top: 12px;">
            <div class="time-config">
              <button class="btn btn-primary" @click="sendWsMessage('record_mode_enable')">进入录音模式</button>
              <button class="btn btn-primary" @click="sendWsMessage('record_mode_disable')">进入回放模式</button>
              <button class="btn btn-primary" @click="sendWsMessagee('pause playback')">暂停播放</button>
              <button class="btn btn-primary" @click="sendWsMessage('resume playback')">恢复播放</button>
              <button class="btn btn-primary" @click="sendWsMessage('stop playback')">停止播放</button>
            </div>
          </div>

          <p class="desc">
            {{deviceStatus}}
            <!-- 通过设定时间段，终端设备将在指定的休息时间内自动进入录音模式，并在休息期间通过人声识别触发报警。 -->
          </p>

          <AudioPlayer ref="audioPlayer" :fileList="fileList" :deviceId="deviceId"   @playWeb="handlePlayWeb" 
      @playDevice="handlePlayDevice" @fileNotFound="handleFileNotFound"  @handleDevicePlay="handleDevicePlay"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderLogo from '@/components/HeaderLogo.vue'
import AudioPlayer from '@/components/AudioPlayer.vue'
import {sendMessage } from '@/utils/wsInstance'
import { EventBus } from '@/utils/eventBus'  
import { getTaskByGroupId,updateTaskTime} from '@/api/api'
export default {
  name: 'TerminalOperation',
  components: { HeaderLogo, AudioPlayer },
props: {
    deviceId: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      online: true,
      ip: '192.168.1.200',
      noonId:null,
      nightId:null,
      noonStart: '',
      noonEnd: '',
      nightStart: '',
      nightEnd: '',
      wsClient: null,
      token:null,
      deviceStatus:' ',
      fileList: [],
      loading:'',
      fileName:'',
      timer:null
    }
  },
  computed: {
   
  },
  mounted() {
   EventBus.$on('ws-message', this.handleMessage);
   this.sendWsMessage('record_mode_disable')
   // this.getRecordList()
   setTimeout(() => {
     this.sendWsMessage("get device status");
    }, 100); 
     
    setTimeout(() => {
    this.sendWsMessage('list_record_files')
    }, 300); 

    this.timer = setInterval(()=>{
     this.sendWsMessage("get device status");
    },3000)

setInterval(()=>{
 this.sendWsMessage("get device status");
  // this.sendWsMessage('list_record_files')
    },2000)
  //  this.findTask()
  },

   destroyed() {
   
    // 清理定时器，避免内存泄漏
    clearInterval(this.timer);
  
  
  },
  methods: {
 handleFileNotFound(fileName) {
     
      this.fileName = fileName;
      this.sendWsMessage("uploadFile:/RECORDER/"+fileName);
    },

      handleDevicePlay(fileName) {
     
      this.sendWsMessage(`play:0:RECORDER/${fileName}`);
    },

handlePlayWeb() {
      console.log('网页播放');
      // 在这里执行具体的操作，比如网页播放逻辑
    },
    // 父组件的方法，处理终端播放
    handlePlayDevice() {
      console.log('终端播放');
      // 在这里执行具体的操作，比如终端播放逻辑
    },

     // 处理 WebSocket 接收到的消息
    handleMessage(data) {
       
      if(data.type == 'commandResult' && data.deviceRecordId == this.deviceId){
        
        if(data.data == 'Device set to playback mode and currently idle'){
          this.deviceStatus = '提示：终端当前处于回放模式且空闲状态。'
        }else if(data.data == 'Device set to playback mode and currently playing'){
this.deviceStatus = '提示：终端当前处于回放模式且播放状态。'
        }else if(data.data == 'Device set to recording mode and currently idle'){
this.deviceStatus = '提示：终端当前处于录音模式且空闲状态。'
        }else if(data.data == 'Device set to recording mode and currently recording'){
this.deviceStatus = '提示：终端当前处于录音模式且录音状态。'
        }else if (data.data.startsWith('REC')) {
          const fileName = data.data;
      // 判断文件是否已经存在于 fileList 数组中
      
      const fileExists = this.fileList.some(file => file === fileName);

      // 如果文件不存在，添加到 fileList
      if (!fileExists) {
       
        this.fileList.push(fileName.split('.wav')[0] + '.wav');
      
      } else {
       
      }
      }else if(data.data.match(/^uploadFile:(.+)$/)){
        const match = data.data.match(/^uploadFile:(.+)$/);
    
      // 如果匹配成功，获取文件名
      if (match) {
        const fileName = match[1]; // match[1] 是正则表达式中第一个括号捕获的内容，即文件名
         console.log(data.data)
          console.log(fileName)
        if(this.fileName == fileName){
           this.loading = this.$loading({
        lock: true,
        text: '文件正在上传中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.6)'
      });

 
        }    
      }
      }else if(data.data == 'stop_recording'){
          this.sendWsMessage('list_record_files')
      }
    
      }else if(data.type == "serverResult"){
        const match = data.data.match(/^receiveFile:(.+)$/);
      
      // 如果匹配成功，获取文件名
      if (match) {
        const fileName = match[1]; // match[1] 是正则表达式中第一个括号捕获的内容，即文件名
        if(this.fileName == fileName){
          this.$refs.audioPlayer.playWebAudio(this.deviceId,this.fileName);
          setTimeout(()=>{
            this.loading.close();
          },2000)
          this.fileName = ''
        }    
      }
      }
    },
    
    // 处理 WebSocket 连接成功
    handleOpen() {
      
    },
    
    // 处理 WebSocket 连接关闭
    handleClose() {
      console.log('WebSocket connection closed');
    },

    getRecordList(){

    //  this.sendWsMessage('record_mode_disable')
    //  this.sendWsMessage('list_record_files')
    //  setTimeout(() => {
    //   // 定义第二个命令对象
    //   const secondCmd = {
    //     type: "command",
    //     data: {
    //       deviceId: this.deviceId.toString(),  // 假设 deviceId 是你在组件中定义的变量
    //       format: "ascill",
    //       command: "list_record_files"  // 第二个命令
    //     }
    //   };

    //   // 将第二个命令对象转换为 JSON 字符串
    //   const secondCmdJson = JSON.stringify(secondCmd);

    //   // 发送第二个命令到 WebSocket
    //   sendMessage(secondCmdJson);
    // }, 30); 
    
    },
    
sendWsMessage(cmd) {
 
    // 定义命令对象
    const commandData = {
      type: "command",
      data: {
        deviceId: this.deviceId.toString(),  // 假设 deviceId 是你在组件中定义的变量
        format: "ascill",  // 请确认这里是否需要传递这个参数
        command: cmd // 使用传入的 cmd 参数
      }
    };

    // 将对象转换为 JSON 字符串
    const cmdJson = JSON.stringify(commandData);

    // 发送 JSON 字符串到 WebSocket
   sendMessage(cmdJson);
  
}


//  async findTask() {
//   try {
//     console.log(this.group);

//     const res = await getTaskByGroupId(this.group.deviceGroupId);
//     console.log(res)
//     if (res.code === 0 && Array.isArray(res.data)) {
//       // 初始化默认值
//       this.noonStart = '';
//       this.noonEnd = '';
//       this.nightStart = '';
//       this.nightEnd = '';
//       this.noonId = null;
//       this.nightId = null;

//       for (const d of res.data) {
//         if (d.taskType === 'NOON') {
//           this.noonStart = d.startTime;
//           this.noonEnd = d.endTime;
//           this.noonId = d.id
//         } else if (d.taskType === 'NIGHT') {
//           this.nightStart = d.startTime;
//           this.nightEnd = d.endTime;
//           this.nightId = d.id
//         }
//       }
//         console.log("this.noonStart")
//       console.log(this.noonStart)
//     }
//   } catch (err) {
//     console.error('获取任务失败:', err);
//   }
// },

//     toggleOnline() {
//       this.online = !this.online
//     },
//   async saveNoon() {
//   try {
//     // ✅ 校验任务ID
//     if (!this.noonId) {
//       alert("任务不存在或尚未创建！");
//       return;
//     }

//     // ✅ 校验时间
//     if (!this.noonStart || !this.noonEnd) {
//       alert("时间格式无效，请检查开始和结束时间");
//       return;
//     }

//     // ✅ 参数对象
//     const form = {
//       deviceGroupId: this.group.deviceGroupId,
//       taskId: this.noonId,
//       startTime: this.noonStart,
//       endTime: this.noonEnd
//     };

//     // ✅ 发起更新请求
//     const res = await updateTaskTime(form);

//     // ✅ 响应结果处理
//     if (res.code === 0) {
//       alert("中午休息时间已更新！");
//     } else {
     
//     }
//   } catch (err) {
  
//     alert("更新失败，请检查网络或服务器状态。");
//   }
// },

//    async saveNight() {
//        try {
//     // ✅ 校验任务ID
//     if (!this.nightId) {
//       alert("任务不存在或尚未创建！");
//       return;
//     }

//     // ✅ 校验时间
//     if (!this.nightStart || !this.nightEnd) {
//       alert("时间格式无效，请检查开始和结束时间");
//       return;
//     }

//     // ✅ 参数对象
//     const form = {
//       deviceGroupId: this.group.deviceGroupId,
//       taskId: this.nightId,
//       startTime: this.nightStart,
//       endTime: this.nightEnd
//     };

//     // ✅ 发起更新请求
//     const res = await updateTaskTime(form);

//     // ✅ 响应结果处理
//     if (res.code === 0) {
//       alert("夜间休息时间已更新！");
//     } else {
     
//     }
//   } catch (err) {
//     console.log(err)
//     alert("更新失败，请检查网络或服务器状态。");
//   }
    
//     },
//     goAlarms() {
//       this.$router.push({
//         name: 'AlarmRecords',
//         params: { group: this.group }
//       })
//     }
  }
}
</script>
<style scoped>
/* 基础布局 */
.terminal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.terminal-body .row {
  display: flex;
  align-items: flex-start;
  font-size: 14px;
  margin-top: 6px;
  color: #e5e7eb;
}

.row-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  color: #e5e7eb;
}

.time-config {
  display: flex;
  flex-direction: row;
  gap: 40px;
  margin-left: 0;
  width: 100%;
  max-width: 520px;
}

.time-config .btn {
  padding: 12px 24px;
  font-size: 16px;
}

/* 描述文字样式 */
.desc {
  margin: 16px 0;
  font-size: 13px;
  color: #9ca3af;
}

@media (max-width: 700px){

.time-config {
    flex-direction: column;
      gap: 20px;
}


.time-config .btn{
   margin-left: 0px;
 
}
}
/* @media (max-width: 768px) {
  .time-config{
    flex-wrap:wrap;
    gr
  }
} */

/* 屏幕适配 */
@media (max-width: 900px) {
  .terminal-header {
    /* flex-direction: column; */
    align-items: flex-start;
  }

  .time-config {
    margin-left: 0;
    max-width: 100%;
  }

  .time-config .btn {
    width: 100%;
    font-size: 14px;
    padding: 10px;
  }

  .desc {
    font-size: 12px;
  }
}

@media (max-width: 480px) {
  .time-config .btn {
    font-size: 14px;
    padding: 8px 16px;
  }
}
</style>